import Switching1 from '@icons/Switching1.svg';
import Switching2 from '@icons/Switching2.svg';
import Switching3 from '@icons/Switching3.svg';
import type { SwitchingToPBSectionCard } from '@components/widgets';

/**
 * “Switching to PB” solution cards for the brokers use case (white-labeled ICHRA).
 */
export const BROKERS_SWITCHING_TO_PB_CARDS: SwitchingToPBSectionCard[] = [
    {
        iconSrc: Switching1,
        iconAlt: '',
        title: '80% Cost Reduction',
        description:
            'Instead of the industry-average $35 PEPM, PB provided a flat, transparent SaaS fee that averaged $5 PEPM.',
        listItems: [
            'Traditional Platform Cost: $50,400/year',
            'Predictable Benefits Cost: $10,080/year',
            'Immediate Savings: $40,320 (Reinvested into the client\'s plan design).',
        ],
    },
    {
        iconSrc: Switching2,
        iconAlt: '',
        title: 'Total Brand Control',
        description:
            'The Broker Firm uploaded their logo, selected their agency colors, and pointed the portal to their own subdomain. When employees enrolled, they saw "Brokerage Firm Portal," not a third-party tech company.',
    },
    {
        iconSrc: Switching3,
        iconAlt: '',
        title: 'BOR Protection',
        description:
            'Unlike other platforms, PB is a pure SaaS tool. The benefits broker remained the exclusive Broker of Record, ensuring they kept 100% of the commissions and maintained a direct, unmediated relationship with the employer.',

    },
];
